import PropTypes from "prop-types";
import { Select } from "antd";
import SelectArrow from "../selectArrow";
import "./styles.scss";

const SelectBorder = ({ options, onSelect, onChange, value }) => {
  return (
    <div className="SelectCustomBorder">
      <Select
        value={value}
        onSelect={onSelect}
        onChange={onChange}
        suffixIcon={SelectArrow}
      >
        {options.map((option) => (
          <Select.Option key={option} value={option}>
            {option}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

SelectBorder.defaultProps = {
  options: [{ id: "key", title: "value" }],
  onSelect: () => {
    return true;
  },
  onChange: () => {
    return true;
  },
  value: null,
};

SelectBorder.propTypes = {
  options: PropTypes.array,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.any,
};

export default SelectBorder;
